const FontsSideBarData = [
  {
    collapse: "Type",
    icon: "bi bi-type",
    icon1: [],
    tag: 1,
    tags: [
      "All",
      "Serif",
      "Sans Serif",
      "Display",
      "Slab serif",
      "Script",
      "Monospace",
    ],
    id: "typeCollapse",
    page: "fontsgrid",
  },
];
export default FontsSideBarData;
